<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>知识库</el-breadcrumb-item>
      <el-breadcrumb-item>设备知识库</el-breadcrumb-item>
    </el-breadcrumb>
    <WikiIndex :type="1"></WikiIndex>
  </div>
</template>

<script>
import WikiIndex from './index.vue'
export default {
  components: {
    WikiIndex,
  },
}
</script>